import React from "react";
import "./../../UaeAttestation/UaeReq/UaeReq.css";
import KuwaitReqMain from "./KuwaitReqMain";

const KuwaitReq = () => {
  return (
    <div className="uaeReqContainer">
      <KuwaitReqMain />
    </div>
  );
};

export default KuwaitReq;
